import type { Language } from '../types';

export interface AvailableLanguage {
    language: Language;
}

export function getMetaLinksFromAvailableLanguages({
    availableLanguages,
    currentLanguage,
    pathname,
    storeUrl,
}: {
    availableLanguages: AvailableLanguage[];
    currentLanguage: Language;
    pathname: string;
    storeUrl?: string;
}): { language: Language; href: string }[] {
    const branchName = APP_ENV.DEV_BRANCH ?? '';
    const url = storeUrl?.replace('%BRANCH%', branchName);

    let path = pathname.replace(`/${currentLanguage}`, '');

    // handle HG store
    if (storeUrl?.endsWith('/de')) {
        path = path.replace('/de', '');
    }

    if (branchName) {
        path = path.replace(`/${branchName}`, '');
    }

    return availableLanguages.map(({ language }) => {
        const href = path ? `${url}/${language}${path}` : `${url}/${language}`;

        return {
            href: href.endsWith('/') ? href.slice(0, -1) : href,
            language,
        };
    });
}
